/** `roles` mag één naam of een lijst zijn. */
export const authGuardRoles = (roles) => Array.isArray(roles) ? roles : (roles ? [roles] : [])

/**
 * Mag dit account hier zijn?
 *
 * Elke eis die je opgeeft moet kloppen; binnen één eis is één rol genoeg. Geef je zowel `roles` als
 * `clientRoles` op, dan zijn ze dus allebei nodig. Eerder gold "één van de twee is genoeg", en dat
 * viel verkeerd uit: bij alleen `clientRoles` was `roles` leeg, wat als "geen eis" gold, en dan
 * kwam iedereen die was ingelogd binnen.
 *
 * Een clientrol is een tweede soort recht, bijvoorbeeld `manage-users` van `realm-management`. Die
 * staat in `resourceAccess` van het token en niet tussen de realm-rollen.
 *
 * Los van het component, zodat de toets zelf te testen is zonder een pagina te renderen.
 */
export const authGuardAllows = ({ accountInfo, roles, clientRoles }) => {
  if (!accountInfo) return false

  const required = authGuardRoles(roles)
  const granted = accountInfo.resourceAccess?.[clientRoles?.client]?.roles || []

  const hasRealmRole = !required.length || required.some(role => accountInfo.roles?.includes(role))
  const hasClientRole = !clientRoles || (clientRoles.roles || []).some(role => granted.includes(role))

  return hasRealmRole && hasClientRole
}

/** Wie een tank mag bewerken, zoals `PUT /eggspedition/tank/{id}`. Aanmaken blijft `aquarist-admin`. */
export const TANK_EDIT_ROLES = ["aquarist-admin", "admin"]

/** Mag dit account deze waarneming wijzigen? De melder zelf of een admin, dezelfde regel als de API. */
export const mayModifyObservation = (accountInfo, observation) => Boolean(accountInfo) && (
  Boolean(accountInfo.roles?.includes("admin"))
  || (Boolean(observation?.user_id) && observation.user_id === accountInfo.id)
)
